import { Radio } from '@dixa/lib-shared-habla';
import { ComponentProps } from 'react';
import { WrappedFieldProps } from 'redux-form';

type FieldRadioProps = WrappedFieldProps &
  Omit<ComponentProps<typeof Radio>, 'ref'>;

export function FieldRadio({
  input,
  meta,
  ...radioProps
}: FieldRadioProps): JSX.Element {
  return <Radio {...input} {...radioProps} />;
}
